module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/otwarcie/big/2-91fcd5d69c9b429ab877432b469e47bc.webp";